export default "__VITE_ASSET__GU__3cMz__"